import { useState, useEffect } from 'react';

import CodeMirror from '@uiw/react-codemirror';
import { Field, FormRenderProps, FormMeta, ValidateTrigger } from '@flowgram.ai/free-layout-editor';
import { Input, Select } from '@douyinfe/semi-ui';
import { javascript } from '@codemirror/lang-javascript';

import { getFieldValue, setFieldValue } from '../../utils/common';
import { FlowNodeJSON } from '../../typings';
import { useIsSidebar } from '../../hooks';
import { FormHeader, FormContent, FormOutputs, FormItem } from '../../form-components';

export const renderForm = ({ form }: FormRenderProps<FlowNodeJSON>) => {
  const isSidebar = useIsSidebar();

  const [domain, setDomain] = useState<string>(getFieldValue('domain', form) || '');
  const [url, setUrl] = useState<string>(getFieldValue('url', form) || '');
  const [serviceType, setServiceType] = useState<string>(
    getFieldValue('serviceType', form) || 'CLOUD_FUNCTION'
  );
  const [params, setParams] = useState<string>(getFieldValue('params', form) || '{}');

  // 确保在初始化时设置默认值到表单中
  useEffect(() => {
    if (!getFieldValue('serviceType', form)) {
      setFieldValue('serviceType', 'CLOUD_FUNCTION', form);
    }
  }, [form]);

  if (isSidebar) {
    return (
      <>
        <FormHeader />
        <FormContent>
          <Field
            name="domain"
            render={({ field }) => (
              <Input
                {...field}
                value={domain}
                onChange={(value) => {
                  setDomain(value);
                  setFieldValue('domain', value, form);
                }}
                placeholder="请输入域名"
              />
            )}
          />
          <Field
            name="url"
            render={({ field }) => (
              <Input
                {...field}
                value={url}
                onChange={(value) => {
                  setUrl(value);
                  setFieldValue('url', value, form);
                }}
                placeholder="请输入 URL"
              />
            )}
          />
          <Field
            name="serviceType"
            render={({ field }) => (
              <Select
                {...field}
                value={serviceType}
                onChange={(value) => {
                  const stringValue = value as string;
                  setServiceType(stringValue);
                  setFieldValue('serviceType', stringValue, form);
                }}
                placeholder="请选择服务类型"
              >
                <Select.Option value="CLOUD_FUNCTION">云函数</Select.Option>
                <Select.Option value="CLOUD_HOSTING">云托管</Select.Option>
              </Select>
            )}
          />
          <Field
            name="params"
            render={() => (
              <CodeMirror
                value={params}
                height="200px"
                extensions={[javascript()]}
                onChange={(value) => {
                  setParams(value);
                  setFieldValue('params', value, form);
                }}
                basicSetup={{
                  lineNumbers: true,
                  autocompletion: true,
                  bracketMatching: true,
                  indentOnInput: true,
                  foldGutter: true,
                }}
              />
            )}
          />
        </FormContent>
      </>
    );
  }
  return (
    <>
      <FormHeader />
      <FormContent>
        <FormOutputs />
        <FormItem name="Domain" type="string">
          {domain}
        </FormItem>
        <FormItem name="URL" type="string">
          {url}
        </FormItem>
        <FormItem name="Service Type" type="string">
          {serviceType}
        </FormItem>
        <FormItem name="Params" type="json">
          {params}
        </FormItem>
      </FormContent>
    </>
  );
};

export const formMeta: FormMeta<FlowNodeJSON> = {
  render: renderForm,
  validateTrigger: ValidateTrigger.onChange,
  validate: {
    fields: ({ value }) =>
      // TODO: Add validation logic here if needed
      undefined,
  },
};
